import React from "react";
import "./App.css";
import { makeStyles } from "@mui/styles";
import { CssBaseline } from "@mui/material";
import Particles from "../particles_animation/Particles";
import PageBodyContainer from "../components/PageBodyContainer";
import { ThemeProvider } from "@mui/material/styles";
import Theme from "../components/controls/Theme";

const useStyles = makeStyles({
  appRoot: {
    minHeight: "100vh",
    color: "#fafafa",
    backgroundColor: "#1a1a1a",
    fontFamily: "Rajdhani, sans-serif",
  },
});

function App() {
  const classes = useStyles();
  return (
    <ThemeProvider theme={Theme}>
      <div className={classes.appRoot}>
        <CssBaseline />
        <Particles />
        <PageBodyContainer />
      </div>
    </ThemeProvider>
  );
}

export default App;
